interface GetActivityColorProps {
    busy?: boolean;
    lastSeenMinutes: number | null | undefined;
}

export default function getActivityColor({ busy, lastSeenMinutes }: Readonly<GetActivityColorProps>): string {
    if (lastSeenMinutes && lastSeenMinutes < 10 && busy) {
        return 'mlRed.main';
    }

    if (lastSeenMinutes == null) {
        return '#adadb8';
    }

    switch (true) {
        case lastSeenMinutes < 5:
            return 'mlGreen.main';
        case lastSeenMinutes < 10:
            return 'mlYellow.main';
        default:
            return '#adadb8';
    }
}
